import script from "./VirtualZoneItem.vue?vue&type=script&setup=true&lang=js"
export * from "./VirtualZoneItem.vue?vue&type=script&setup=true&lang=js"

import "./VirtualZoneItem.vue?vue&type=style&index=0&id=7803df26&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7803df26"]])

export default __exports__